export const childrenPaths = [
  {
    path: "/screeners/:id/results",
    name: "Screener Results",
    enabledFeatures: ['VUE_FEATURE_SCREENER'],
    meta: {
      menuTitle: "Results",
      title: "Results",
      icon: "bhi-home",
      requiresAuth: true,
      disableLink: true
    },
    component: () => import("@/views/screeners/ScreenerResults.vue")
  },
]

export default [
  {
    path: "/screeners/",
    name: "Screeners",
    availableFeatureFlag: 'surveyAvailable', // Feature flag
    enabledFeatures: ['VUE_FEATURE_SCREENER'],
    meta: {
      title: "Screeners",
      icon: "bhi-clock",
      requiresAuth: true,
    },
    component: () => import("@/views/Screeners.vue"),
  },
  {
    path: "/screeners/:id",
    name: "Screener",
    hidden: true,
    enabledFeatures: ['VUE_FEATURE_SCREENER'],
    meta: {
      title: "Screener",
      icon: "bhi-clock",
      requiresAuth: true
    },
    redirect: {
      name: "Screener Results",
    },
    component: () => import("@/views/Screener.vue"),
    children: childrenPaths
  },
]